import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateSavedReportRightsForUserMutation } from "org/user/queries/useUpdateSavedReportRightsForUserMutation";
import { UserOrUserGroupOverview } from "utils/user";

import { SavedReportRow } from "./useUserSavedReportsListTable";

interface UseReplaceSavedReportUserUtilsProps {
    userId: number;
    selectedRows: Row<SavedReportRow>[];
    deselectAll: () => void;
}

export function useReplaceSavedReportUserUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseReplaceSavedReportUserUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutateAsync, isPending } =
        useUpdateSavedReportRightsForUserMutation();

    const replaceUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const replaceUser = async (userOrGroup: UserOrUserGroupOverview) => {
        const savedReportIds = selectedRows.map((row) => row.original.id);
        const newUserId = userOrGroup.id;

        try {
            await mutateAsync({
                userId,
                data: { newUserId, savedReportIds },
            });
            deselectAll();
            setIsModalOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    return {
        replaceUserToolState,
        isReplaceUserModalOpen: isModalOpen,
        openReplaceUserModal: () => setIsModalOpen(true),
        closeReplaceUserModal: () => setIsModalOpen(false),
        replaceUser,
        isReplacingUser: isPending,
    };
}
